function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:currentColor}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "\\u30EC\\u30A4\\u30E4\\u30FC_2",
  "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u30EC\\u30A4\\u30E4\\u30FC_2-2",
  "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M30.714 23.369h-.025v-7.2H29.7v2.2H9.546l-3.86-9.54L2.171 8.8h-.007a.9.9 0 00-.007 1.8l2.31.017 5.158 12.75h-.1l.972 2.3h20.241zM11.5 23.2l-1.4-3.47h19.6v3.639H11.534a.864.864 0 00-.034-.169zM26.449 26.112a1.685 1.685 0 101.62 1.684 1.653 1.653 0 00-1.62-1.684z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-1",
  cx: 12.766,
  cy: 27.796,
  rx: 1.619,
  ry: 1.684
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M25.232 13.731a1.779 1.779 0 00-1.47-1.3l-1.722-1.724-2.763-2.764a3.828 3.828 0 00.273-.777 3.733 3.733 0 00.1-.844 3.775 3.775 0 00-1.123-2.689 3.851 3.851 0 00-3.545-1.021 3.9 3.9 0 00-.772.262l1.265 1.264L16.736 5.4l-.56 1.371-1.371.56-1.255-1.254-1.256-1.256a3.785 3.785 0 00-.231.723 3.83 3.83 0 00-.08.778 3.776 3.776 0 001.122 2.688 3.838 3.838 0 002.71 1.114 3.9 3.9 0 00.769-.077 3.783 3.783 0 00.716-.22l2.786 2.787 1.65 1.649a1.826 1.826 0 00.056.39 1.781 1.781 0 003.44-.922zm-.754.7l-.011.042a.957.957 0 01-.677.677l-.041.011a.959.959 0 01-.925-.248l-.03-.03a.957.957 0 01-.248-.925l.011-.041a.957.957 0 01.677-.677l.042-.012a.957.957 0 01.924.248l.031.031a.954.954 0 01.247.921z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h32v32H0z"
})));

var SvgWagon2Min = function SvgWagon2Min(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWagon2Min, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Wagon2.min.db83b208.svg";
export { ForwardRef as ReactComponent };